import type { ParsedStatement } from "@paisa/types"
import type { AccountOption } from "./types"

export function findMatchingAccount(
  accounts: AccountOption[],
  parsed: ParsedStatement,
): AccountOption | null {
  if (!parsed.accountNumber) return null
  const sameLast4 = accounts.filter((a) => a.last4 === parsed.accountNumber)
  if (sameLast4.length === 0) return null
  const byBank = sameLast4.find((a) => a.bankName.toLowerCase() === parsed.bank.toLowerCase())
  return byBank ?? sameLast4[0]
}

export function sumByType(
  transactions: { amount: number; type: "debit" | "credit" }[],
  type: "debit" | "credit",
): number {
  return transactions.filter((t) => t.type === type).reduce((s, t) => s + Number(t.amount), 0)
}

export function accountTypeLabel(t: string): string {
  return t === "credit_card" ? "Credit card" : t === "savings" ? "Savings" : t
}
